module.exports = __webpack_public_path__ + "static/EPD-lamppost-sensor-data_inside-banner_sc-e793557bd8d06c8190b8da88a4134902.jpg";